import * as React from "react";
import { Button, Form, Row, Select, Spin } from "antd";
const Option = Select.Option;
import { SelectProps } from "antd/lib/select";
import { contactsStore } from "Stores/ContactsStore";
import { I18N_NS } from "Config/i18n";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { withTranslation, WithTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatUsername } from "utils/formatUsername";

interface UserAndContactSelectionProps extends SelectProps<string[]>, ModalComponentProps, WithTranslation {
  withDisabledId?: boolean;
  value?: string[];
  onSubmit?: (value: (API_User | API_Contact)[]) => void;
}

export const UserAndContactSelection = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<UserAndContactSelectionProps> {
    render() {
      if (contactsStore.state === "LOADING") {
        return <Spin />;
      } else {
        const options = contactsStore.projectUsers
          .filter(({ active }) => active)
          .map((val) => {
            return (
              <Option
                value={JSON.stringify({
                  id: val.id,
                  memberType: "U",
                })}
                name={formatUsername({ firstName: val.firstName, surname: val.surname })} // for filtering
                key={val.id + "_U"}
              >
                <>
                  <FontAwesomeIcon icon={["fas", "user-alt"]} fixedWidth={true} className="icon" />
                  {` ${formatUsername({ firstName: val.firstName, surname: val.surname })}`}
                </>
              </Option>
            );
          })
          .concat(
            contactsStore.globalUserContacts.map((val) => {
              return (
                <Option
                  value={JSON.stringify({
                    id: val.id,
                    memberType: "C",
                  })}
                  name={val.name} // for filtering
                  key={val.id + "_C"}
                >
                  <div>
                    <FontAwesomeIcon icon={["fas", "user-alt"]} fixedWidth={true} className="icon" />
                    <span className="member-avatar-lock-for-list">
                      <FontAwesomeIcon icon={["fas", "globe"]} fixedWidth={true} className="icon" />
                    </span>
                    {` ${val.name}`}
                  </div>
                </Option>
              );
            })
          );
        const { withDisabledId, ...rest } = this.props;

        const { t } = this.props;

        return (
          <>
            <h1>{t("Add Users or Global contacts")}</h1>
            <Form
              onFinish={async (values) => {
                const selected: (API_User | API_Contact)[] = [];
                for (const jsonItem of values.newMembers) {
                  const item = JSON.parse(jsonItem);
                  if (item.memberType === "C") {
                    selected.push(contactsStore.globalUserContacts.find((c) => c.id === item.id));
                  } else if (item.memberType === "U") {
                    selected.push(contactsStore.projectUsers.find((u) => u.id === item.id));
                  }
                }
                this.props.onSubmit(selected);
                this.props.hideModal();
              }}
            >
              <Form.Item name="newMembers" rules={[{ required: true, message: t("Please specify at least one user") }]}>
                <Select
                  showSearch={true}
                  placeholder={t("Select a user to be added")}
                  optionFilterProp="name"
                  mode="multiple"
                  value={this.props.value}
                  {...rest}
                >
                  {withDisabledId && (
                    <Option
                      name={t("Deactivated", { ns: I18N_NS.ADMIN })} // for filtering
                      value={-1}
                    >
                      {t("Deactivated", { ns: I18N_NS.ADMIN })}
                    </Option>
                  )}
                  {options}
                </Select>
              </Form.Item>
              <Row justify="space-between">
                <Button onClick={this.props.hideModal}>{t("Abort")}</Button>
                <Button htmlType="submit" type="primary">
                  {t("Add")}
                </Button>
              </Row>
            </Form>
          </>
        );
      }
    }
  }
);
